// extracted by mini-css-extract-plugin
export var padded = "BetSpine-module--padded--30a44";
export var spine = "BetSpine-module--spine--fa86f";